import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import ModernNenaMiami from './components/ModernNenaMiami';
import ContactPage from './components/ContactPage';
import CakesPage from './components/CakesPage';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import Cart from './components/Cart';

function App() {
  const [isCartOpen, setIsCartOpen] = useState(false);

  return (
    <CartProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<ModernNenaMiami onCartOpen={() => setIsCartOpen(true)} />} />
          <Route path="/contact" element={<ContactPage onCartOpen={() => setIsCartOpen(true)} />} />
          <Route path="/cakes" element={<CakesPage onCartOpen={() => setIsCartOpen(true)} />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
        <Cart isOpen={isCartOpen} onClose={() => setIsCartOpen(false)} />
      </Router>
    </CartProvider>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

export default App;